import { useGetList } from "ra-core";

import type { InventoryItem } from "../types";
import { nextMonthStart } from "./inventoryStats";

/** Generous, fixed page size (same convention as `useAdvisorProgress`): one bounded query, never one per advisor. */
export const MAX_MONTH_OPTIONS = 2000;

/**
 * The options listed in the month of `monthStart` (`YYYY-MM-01`), in ONE bounded query. Callers
 * count them per advisor with `capturedInMonth`; `isTruncated` is true when the cap cut the list,
 * so a figure must not be presented as complete.
 */
export const useMonthCaptures = (monthStart: string, enabled: boolean) => {
  const result = useGetList<InventoryItem>(
    "inventory_items",
    {
      pagination: { page: 1, perPage: MAX_MONTH_OPTIONS },
      sort: { field: "added_on", order: "DESC" },
      filter: {
        source: "option",
        "added_on@gte": monthStart,
        "added_on@lt": nextMonthStart(monthStart),
      },
    },
    { enabled },
  );
  return {
    options: result.data ?? [],
    isPending: enabled && result.isPending,
    error: result.error,
    isTruncated: (result.total ?? 0) > (result.data?.length ?? 0),
    refetch: result.refetch,
  };
};
